import { render } from "./PublicationsForm.vue?vue&type=template&id=abf0bfce&scoped=true"
import script from "./PublicationsForm.vue?vue&type=script&lang=js"
export * from "./PublicationsForm.vue?vue&type=script&lang=js"

import "./PublicationsForm.vue?vue&type=style&index=0&id=abf0bfce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abf0bfce"]])

export default __exports__